import { getDmService } from '../../services/Api';

const RECEIVE_USER_DATA = 'RECEIVE_USER_DATA';

const INITIAL_STATE = {
  data: JSON.parse(localStorage.getItem('user')) || {},
};

export const reducer = (prevState = INITIAL_STATE, action) => {
  if (action.type === RECEIVE_USER_DATA) {
    return { ...prevState, data: action.payload };
  }
  return prevState;
};

/* ------- Actions ------ */
const receiveUserData = () => async dispatch => {
  try {
    const data = await getDmService('/Usuario/Me');
    dispatch({
      type: RECEIVE_USER_DATA,
      payload: data,
    });
  } catch (e) {
    console.error(e);
  }
};

export default {
  receiveUserData,
};



// WEBPACK FOOTER //
// ./src/redux/modules/user.js